/* global Swiper */
document.querySelectorAll( '.b-testimonial-slider' ).forEach( ( block ) => {

	if ( typeof window.Swiper !== 'function' ) {

		return;

	}

	/**
	 * Tell whether the visitor asked for as little motion as the interface can get away with.
	 *
	 * @return {boolean} True when the reduced-motion preference is set.
	 */
	const prefersReducedMotion = () => window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	const sliderEl = block.querySelector( '.b-testimonial-slider__slider' );

	if ( ! sliderEl ) {

		return;

	}

	const prevEl = block.querySelector( '.b-testimonial-slider__nav-button--prev' );
	const nextEl = block.querySelector( '.b-testimonial-slider__nav-button--next' );

	// Cards are wp:wombat/testimonial-quote blocks with no dedicated slide-wrapper element
	// of their own (see track/save.js) — add Swiper's expected slide class to each card's
	// own root here, at runtime, instead of baking a Swiper-specific class into the block's
	// saved markup.
	sliderEl.querySelectorAll( '.wp-block-wombat-testimonial-quote' ).forEach( ( card ) => {

		card.classList.add( 'swiper-slide' );

	} );

	new Swiper( sliderEl, {
		slidesPerView: 1,
		spaceBetween: 8, // --wp--preset--spacing--xxs (mobile gap, per Figma)
		loop: false,
		watchOverflow: true,
		speed: prefersReducedMotion() ? 0 : 400,
		a11y: {
			enabled: true,
			prevSlideMessage: prevEl?.getAttribute( 'aria-label' ),
			nextSlideMessage: nextEl?.getAttribute( 'aria-label' ),
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
		breakpoints: {
			992: {
				slidesPerView: 2.3,
				spaceBetween: 16, // --wp--preset--spacing--xs (desktop gap, per Figma)
			},
		},
	} );

} );
